export default function getCookieMaxAgeSeconds(expirationTime: string): number {
  return Math.max(
    0,
    Math.floor((new Date(expirationTime).getTime() - Date.now()) / 1000),
  );
}
